import { Checkbox, FormControlLabel } from "@mui/material"
import type { FC } from "react"

import type { Location } from "@/graphql/codegen/graphql"

export const LocationCheckbox: FC<{
  location: Location
  value: string[]
  onChange: (newValue: string[]) => void
}> = ({ location, value, onChange }) => {
  const isChecked = value.includes(location.locationId)

  const handleCheckboxChange = (checked: boolean) => {
    const values = checked ? [...value, location.locationId] : value.filter((v) => v !== location.locationId)

    onChange(values)
  }

  return (
    <FormControlLabel
      control={<Checkbox checked={isChecked} onChange={(e) => handleCheckboxChange(e.target.checked)} />}
      label={location.name}
    />
  )
}
